import styled, { css } from "styled-components";
import { Button } from "../";
import { device } from "../../../globalStyles/breakpoints";

interface IButton {
  title: string;
  type?: "filled";
  className?: string;
  color?: string;
  disabled?: boolean;
  fontSize?: number;
  noPadding?: boolean;
}

export const ReportButtonFilledHoverStyles = css`
  transition: opacity 0.2s;
  &:hover {
    opacity: 0.7;
  }
`;

export const ReportButtonGhostHoverStyles = css`
  transition: border-color 0.2s;
  &:hover {
    border-color: #aaaaaa;
  }
`;

export const ReportButton = styled(Button)`
  height: 41px;
  display: flex;
  width: initial;
  justify-content: center;

  ${(props: IButton) =>
        props.disabled
            ? `cursor: default;
       opacity: 0.3;`
            : ""}
  color: ${(props: IButton) => (props.color ? props.color : "black")};
  ${(props: IButton) =>
        props.type === "filled"
            ? ReportButtonFilledHoverStyles
            : ReportButtonGhostHoverStyles};

  ${device.desktop} {
    width: 100%;
  }
`;

export const ReportActionButton = styled(Button)`
  width: 100%;
  display: flex;
  height: 38px;
  padding-right: ${(props: IButton) => (props.noPadding ? "0" : "16px")};
  padding-left: ${(props: IButton) => (props.noPadding ? "0" : "16px")};
  justify-content: center;
  align-items: center;
  border-style: solid;
  border-width: 1px;
  border-color: #f0f0f0;
  border-radius: 4px;
  background-color: #fff;
  cursor: pointer;
  color: #141414;
  margin: 0;
  font-size: ${(props: IButton) =>
        props.fontSize ? `${props.fontSize}px` : "15px"};
  ${(props: IButton) =>
        props.type === "filled"
            ? ReportButtonFilledHoverStyles
            : ReportButtonGhostHoverStyles};
  ${(props: IButton) =>
        props.disabled
            ? `cursor: default;
         opacity: 0.3;`
            : ""}
`;

export const ButtonWrap = styled("div")`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 285px;

  ${device.desktop} {
    width: 100%;
  }

  @media print {
    display: none;
  }
`;
